var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dashbi",staticClass:"sub-dashbi-wrap",attrs:{"id":"sub-dashbi"}})}
var staticRenderFns = []

export { render, staticRenderFns }